export default __webpack_public_path__ + "static/media/OnibusFill.e422b379.svg";